import { Input } from '@mgmresorts/wcl-lab';
import React, { useContext } from 'react';

import { useContent } from '../../../../hooks/useContent';
import { MaxLengths } from '../../../../utils/constants';
import { MlifeActivationContext } from '../../MlifeActivationContext';

export function FirstName() {
  const { activationRequest } = useContext(MlifeActivationContext);
  const { getContentByPath } = useContent();

  return (
    <Input
      label={getContentByPath('mlifeActivation.accountSetupSection.fields.firstName.title')}
      id='firstName'
      testId='firstName'
      disabled
      aria-label={getContentByPath('mlifeActivation.accountSetupSection.fields.firstName.label')}
      className={`identity__field identity__field-firstName`}
      value={activationRequest?.fName ?? ''}
      maxLength={MaxLengths.FirstName}
    />
  );
}

FirstName.displayName = 'FirstNameField';
